module.exports = __webpack_public_path__ + "img/login-illustration.69d14dd0.svg";